export const ANALYTICS_CONSENT_STORAGE_KEY = "ordersco-analytics-consent";
export const ANALYTICS_CONSENT_ACCEPTED = "accepted";
export const ANALYTICS_CONSENT_DECLINED = "declined";
export const ANALYTICS_CONSENT_UPDATED_EVENT = "ordersco-analytics-consent-updated";

const isValidConsentValue = (value) =>
  value === ANALYTICS_CONSENT_ACCEPTED || value === ANALYTICS_CONSENT_DECLINED;

export const getAnalyticsConsent = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const value = window.localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY);
    return isValidConsentValue(value) ? value : null;
  } catch (error) {
    return null;
  }
};

export const hasAnalyticsConsent = () =>
  getAnalyticsConsent() === ANALYTICS_CONSENT_ACCEPTED;

export const setAnalyticsConsent = (value) => {
  if (typeof window === "undefined" || !isValidConsentValue(value)) {
    return;
  }

  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, value);
  } catch (error) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(ANALYTICS_CONSENT_UPDATED_EVENT, {
      detail: { value },
    })
  );
};
